import { render, staticRenderFns } from "./HiperCardIcon.vue?vue&type=template&id=f904aa5a"
import script from "./HiperCardIcon.vue?vue&type=script&lang=js"
export * from "./HiperCardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports